import { colors, typography } from '@insurancemenu/imenu-components-lib/dist/utils';
import styled from 'styled-components';

export const WrapperStyled = styled.div`
  display: flex;
  align-items: center;
  gap: 0.8rem;
  color: ${colors.neutral[900]};
`;

export const TextStyled = styled.p`
  ${typography.regular[16]}
  margin: 0;
`;
